import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { DtCrud, initDtCrud, mapObjToCreateObj } from '../../../models/dt.model';
import { DtService } from '../../../services/dt.service';
import { ToastrService } from 'ngx-toastr';
import { Area } from '../../../models/area.model';
import { AreaService } from 'shared-lib';
import { Feeder11Service } from 'shared-lib';
import { Feeder33Service } from 'shared-lib';
import { Feeder, FeederType } from '../../../models/feeder.model';
import { ChecklistItem } from '../../../models/checklist-item.model';
import { MeterType } from '../../../models/meter.model';
import { MeterService } from '../../../services/meter.service';
import { UtilitySharedService } from '../../../shared/_services/utility-shared.service';


@Component({
  selector: 'app-crud-dt',
  templateUrl: './crud-dt.component.html',
  styleUrl: './crud-dt.component.scss',
  standalone: false
})
export class CrudDtComponent implements OnInit {
  pageSize: number = 10;
  currentPage: number = 1;
  count: number = 0;
  utilityId: number = 0;
  searchValue: string = '';
  dts: DtCrud[] = [];
  selectedDt: DtCrud = initDtCrud();
  updatedDt: DtCrud = initDtCrud();
  areas: Area[] = [];
  filteredAreas: Area[] = [];
  feeders: Feeder[] = [];
  filteredFeeders: Feeder[] = [];
  selectedFeeder: Feeder | null = null;
  selectedArea: Area | null = null;
  selectedEditArea: Area | null = null;
  selectedEditFeeder: Feeder | null = null;
  meterBrands: MeterType[] = [];
  selectedEditMeterBrand: MeterType | null = null;
  editFeederVoltageOption: string = 'Feeder Voltage';
  editAreaDropdownOpened: boolean = false;
  editFeederDropdownOpened: boolean = false;
  editFeederVoltageDropdownOpened: boolean = false;
  editDistrictSearchText: string = '';
  editFeederSearchText: string = '';
  filteredEditAreas: Area[] = [];
  filteredEditFeeders: Feeder[] = [];
  feederVoltageOption: string = 'Feeder Voltage';
  districtSearchText: string = '';
  feederSearchText: string = '';
  searchDropdownOpened: boolean = false;
  feederVoltageDropdownOpened: boolean = false;
  areaDropdownOpened: boolean = false;
  feederDropdownOpened: boolean = false;
  isEditMode: boolean = false;
  showDeleteModal: boolean = false;
  filtersApplied: boolean = false;
  isLoading: boolean = false;
  checklistItems: ChecklistItem[] = [];
  appliedFilters: ChecklistItem[] = [];

  @ViewChild('filterTemplate', { static: true })
  filterTemplate!: TemplateRef<any>;

  @Output() filterTemplateReady = new EventEmitter<TemplateRef<any>>();

  @Input() set refreshTrigger(_: number) {
    this.filterTemplateReady.emit(this.filterTemplate);
  }

  @ViewChild('closeEditModal') closeEditModal: ElementRef;

  constructor(
    private dtService: DtService,
    private toastr: ToastrService,
    private areaService: AreaService,
    private f11Service: Feeder11Service,
    private f33Service: Feeder33Service,
    private meterService: MeterService,
    private utilitySharedService: UtilitySharedService
  ) {
    this.utilityId = Number(this.utilitySharedService.getUtilityId());
  }

  ngOnInit(): void {
    this.filterTemplateReady.emit(this.filterTemplate);
    this.reloadTable(1);
    this.getAreas();
    this.getMeterBrands();
  }

  resetFilter() {
    this.searchValue = '';
    this.feederVoltageOption = 'Feeder Voltage';
    this.selectedFeeder = null;
    this.feederSearchText = '';
    this.districtSearchText = '';
    this.areas.forEach(area => (area.checked = false));
    this.feeders = [];
    this.filteredFeeders = [];
    this.appliedFilters = [];
    this.filtersApplied = false;
    this.areaDropdownOpened = false;
    this.feederDropdownOpened = false;
    this.feederVoltageDropdownOpened = false;
    this.searchDropdownOpened = false;
    this.reloadTable(1);
  }

  openAddModal() {
    this.isEditMode = false;
    this.selectedDt = initDtCrud();
    this.updatedDt = initDtCrud();
    this.selectedEditArea = null;
    this.selectedEditFeeder = null;
    this.selectedEditMeterBrand = null;
    this.editFeederVoltageOption = 'Feeder Voltage';
    this.editDistrictSearchText = '';
    this.editFeederSearchText = '';
    this.feeders = [];
    this.filteredEditFeeders = [];
    this.filteredEditAreas = [...this.areas];
  }

  openEditModal() {
    this.isEditMode = true;
    this.updatedDt = { ...this.selectedDt };
    this.selectedEditArea = this.selectedDt.area ? { ...this.selectedDt.area } : null;
    this.selectedEditFeeder = this.selectedDt.feeder ? { ...this.selectedDt.feeder } : null;
    this.selectedEditMeterBrand = this.meterBrands.find(b => b.id === this.selectedDt.meterBrandId) || null;
    this.editDistrictSearchText = '';
    this.editFeederSearchText = '';
    this.editFeederVoltageOption = this.selectedDt.feeder?.feederType.toString() == 'KV33' ? '33kV' :
                                  this.selectedDt.feeder?.feederType.toString() == 'KV11' ? '11kV' : 'Feeder Voltage';
    this.feeders = [];
    this.filteredEditFeeders = [];
    if (this.editFeederVoltageOption === '33kV') {
      this.getFeeders33();
    } else if (this.editFeederVoltageOption === '11kV') {
      this.getFeeders11();
    }
    this.filteredEditAreas = [...this.areas];
  }

  closeDeleteModal() {
    this.showDeleteModal = false;
  }

  onCancel() {
    this.showDeleteModal = false;
  }

  selectDt(dt: DtCrud) {
    this.selectedDt = dt;
    this.openEditModal();
  }

  onDeleteDt(dt: DtCrud){
    this.selectedDt = dt;
    this.isEditMode = false;
    this.showDeleteModal = true;
  }

  private getAreas() {
    this.areaService.getAllForOptions(this.utilityId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          const currentCheckedAreas = new Map<number, boolean>(
            this.areas.map(area => [area.id, area.checked || false])
          );
          this.areas = responseData.data || [];
          this.areas.forEach(area => {
            area.checked = currentCheckedAreas.get(area.id) || false;
          });
          this.filteredAreas = [...this.areas];
          this.filteredEditAreas = [...this.areas];
        } else {
          this.toastr.error(responseData?.message || 'Failed to fetch areas');
          this.areas = [];
          this.filteredAreas = [];
          this.filteredEditAreas = [];
        }
      },
      error: (error) => {
        this.toastr.error('Error occurred while fetching areas');
        this.areas = [];
        this.filteredAreas = [];
        this.filteredEditAreas = [];
      },
    });
  }

  private getMeterBrands() {
    this.meterService.getAllMeterTypesForSelect(this.utilityId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.meterBrands = responseData.data || [];
        } else {
          this.toastr.error(responseData?.message || 'Failed to fetch meter brands');
          this.meterBrands = [];
        }
      },
      error: (error) => {
        this.toastr.error('Error occurred while fetching meter brands');
        this.meterBrands = [];
      },
    });
  }

  getMeterBrandName(meterBrandId?: number) {
    return this.meterBrands.find(b => b.id === meterBrandId)?.name;
  }

  getFeeders11() {
    this.f11Service.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.feeders = (responseData.data || []).map((el: any) => ({
            ...el,
            feederType: FeederType.KV11
          }));
          this.filteredFeeders = [...this.feeders];
          this.filteredEditFeeders = [...this.feeders];
        } else {
          this.toastr.error(responseData?.message || 'Failed to fetch 11kV feeders');
          this.feeders = [];
          this.filteredFeeders = [];
          this.filteredEditFeeders = [];
        }
      },
      error: (error) => {
        this.toastr.error('Error occurred while fetching 11kV feeders');
        this.feeders = [];
        this.filteredFeeders = [];
        this.filteredEditFeeders = [];
      },
    });
  }

  getFeeders33() {
    this.f33Service.getAllForSelect(this.utilityId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          if (Array.isArray(responseData.data)) {
            this.feeders = responseData.data.map((el: any) => ({
              ...el,
              feederType: FeederType.KV33
            }));
            this.filteredFeeders = [...this.feeders];
            this.filteredEditFeeders = [...this.feeders];
          } else {
            this.toastr.error('Invalid response: Expected an array of feeders');
            this.feeders = [];
            this.filteredFeeders = [];
            this.filteredEditFeeders = [];
          }
        } else {
          this.toastr.error(responseData?.message || 'Failed to fetch 33kV feeders');
          this.feeders = [];
          this.filteredFeeders = [];
          this.filteredEditFeeders = [];
        }
      },
      error: (error) => {
        this.toastr.error('Error occurred while fetching 33kV feeders');
        this.feeders = [];
        this.filteredFeeders = [];
        this.filteredEditFeeders = [];
      },
    });
  }

  toggleEditAreaDropdown() {
    this.editAreaDropdownOpened = !this.editAreaDropdownOpened;
  }

  toggleEditFeederDropdown() {
    this.editFeederDropdownOpened = !this.editFeederDropdownOpened;
  }

  toggleEditFeederVoltageDropdown() {
    this.editFeederVoltageDropdownOpened = !this.editFeederVoltageDropdownOpened;
  }

  selectEditArea(areaId: number) {
    if(areaId === 0 && this.selectedEditArea?.id !== 0){
      return;
    }
    this.selectedEditArea = this.areas.find(a => a.id === areaId) || null;
    this.editAreaDropdownOpened = false;
    this.editDistrictSearchText = '';
    this.filterDistricts();
  }

  selectEditFeeder(feederId: number) {
    if(feederId === 0 && this.selectedEditFeeder?.id !== 0){
      return;
    }
    this.selectedEditFeeder = this.filteredFeeders.find(f => f.id === feederId) || null;
    this.editFeederDropdownOpened = false;
    this.editFeederSearchText = '';
    this.filterFeeders();
  }

  selectEditMeterBrand(meterBrandId: number) {
    this.selectedEditMeterBrand = this.meterBrands.find(b => b.id === meterBrandId) || null;
  }

  selectEditFeederVoltageOption(option: string) {
    this.editFeederVoltageOption = option;
    this.selectedEditFeeder = null;
    this.editFeederSearchText = '';
    this.feeders = [];
    this.filteredEditFeeders = [];
    if (option === '33kV') {
      this.getFeeders33();
    } else if (option === '11kV') {
      this.getFeeders11();
    }
    this.editFeederVoltageDropdownOpened = false;
  }

  filterDistricts() {
    this.filteredAreas = this.areas.filter(area =>
      area.name.toLowerCase().includes(this.districtSearchText.toLowerCase())
    );
    this.filteredEditAreas = this.areas.filter(area =>
      area.name.toLowerCase().includes(this.editDistrictSearchText.toLowerCase())
    );
  }

  filterFeeders() {
    this.filteredFeeders = this.feeders.filter(feeder =>
      feeder.name.toLowerCase().includes(this.feederSearchText.toLowerCase())
    );
    this.filteredEditFeeders = this.feeders.filter(feeder =>
      feeder.name.toLowerCase().includes(this.editFeederSearchText.toLowerCase())
    );
  }

  toggleAreaDropdown() {
    this.areaDropdownOpened = !this.areaDropdownOpened;
  }

  toggleFeederDropdown() {
    this.feederDropdownOpened = !this.feederDropdownOpened;
  }

  toggleFeederVoltageDropdown() {
    this.feederVoltageDropdownOpened = !this.feederVoltageDropdownOpened;
  }

  toggleSearchDropdown() {
    this.searchDropdownOpened = !this.searchDropdownOpened;
  }

  selectFeeder(feeder: Feeder) {
    this.selectedFeeder = feeder;
    this.feederDropdownOpened = false;
    this.feederSearchText = '';
    this.filtersApplied = true;
    this.applyFilter();
  }

  selectFeederVoltageOption(option: string) {
    this.feederVoltageOption = option;
    this.feeders = [];
    this.filteredFeeders = [];
    this.filteredEditFeeders = [];
    this.feederSearchText = '';
    this.editFeederSearchText = '';
    this.selectedFeeder = null;
    this.selectedEditFeeder = null;
    if (option === '33kV') this.getFeeders33();
    if (option === '11kV') this.getFeeders11();
    this.feederVoltageDropdownOpened = false;
    this.applyFilter();
  }

  onSearchChange() {
    if (this.searchValue === '' || this.searchValue.trim() === '') {
      this.searchValue = '';
      this.appliedFilters = this.appliedFilters.filter(f => f.property !== 'dtName' && f.property !== 'dtNumber' && f.property !== 'feederName' && f.property !== 'search');
      this.filtersApplied = this.appliedFilters.length > 0;
      this.applyFilter();
      this.onSearch();
    }
  }

  onSearch() {
    this.currentPage = 1;
    let dataIn = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: this.getFilterObject(),
      utilityId: this.utilityId
    };
    this.applyFilter();
    this.getAllDts(dataIn);
    if (this.searchValue === '') {
      this.filtersApplied = false;
    } else {
      this.filtersApplied = true;
    }
  }

  getFilterObject(): any {
    return {
      search: this.searchValue,
      sortBy: 1,
      selectedAreas: this.areas.filter(area => area.checked).map(area => area.id),
      feederVoltage: this.feederVoltageOption === '33kV' ? 2 : this.feederVoltageOption === '11kV' ? 1 : 0,
      isCrud: 1,
      // feederId: this.selectedFeeder?.id ?? null,
      feederName: this.selectedFeeder?.name
    };
  }

  applyFilter() {
    this.appliedFilters = [];

    if (this.searchValue && this.searchValue.trim() !== '') {
      let property = '';
      let propertyTranslation = '';
      this.appliedFilters.push(
        new ChecklistItem(property, this.searchValue, propertyTranslation, this.searchValue)
      );
    }

    if (this.feederVoltageOption !== 'Feeder Voltage') {
      this.appliedFilters.push(
        new ChecklistItem('feederVoltage', this.feederVoltageOption, 'Feeder Voltage', this.feederVoltageOption)
      );
    }

    const checkedAreas = this.areas.filter(area => area.checked);
    checkedAreas.forEach(area => {
      this.appliedFilters.push(
        new ChecklistItem('area', area.id.toString(), 'District', area.name)
      );
    });

    if (this.selectedFeeder) {
      this.appliedFilters.push(
        new ChecklistItem('feeder', this.selectedFeeder.id.toString(), 'Feeder', this.selectedFeeder.name)
      );
    }

    this.filtersApplied = this.appliedFilters.length > 0;
    this.areaDropdownOpened = false;
    this.feederDropdownOpened = false;
    this.feederVoltageDropdownOpened = false;
    this.searchDropdownOpened = false;
    this.reloadTable(1);
  }

  removeFilter(filter: ChecklistItem) {
    this.appliedFilters = this.appliedFilters.filter(f => f !== filter);

    switch (filter.property) {
      case 'dtName':
      case 'dtNumber':
      case 'feederName':
        this.searchValue = '';
        break;
      case 'feederVoltage':
        this.feederVoltageOption = 'Feeder Voltage';
        this.feeders = [];
        this.filteredFeeders = [];
        this.selectedFeeder = null;
        break;
      case 'area':
        const areaId = parseInt(filter.selectedValue);
        const area = this.areas.find(a => a.id === areaId);
        if (area) area.checked = false;
        break;
      case 'feeder':
        this.selectedFeeder = null;
        this.feederSearchText = '';
        break;
      case 'search':
        this.searchValue = '';
        break;
    }

    this.filtersApplied = this.appliedFilters.length > 0;
    this.reloadTable(1);
  }

  clearFilters() {
    this.selectedFeeder = null;
    this.feederVoltageOption = 'Feeder Voltage';
    this.searchValue = '';
    this.filtersApplied = false;
    this.reloadTable(1);
  }

  private getAllDts(dataIn: any) {
    this.isLoading = true;
    dataIn.isCrud = true;
    this.dtService.getAll(dataIn).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.dts = responseData.data?.data || [];
          this.count = responseData.data?.count ?? this.count;
          if (this.dts.length === 0) {
            this.toastr.info('No data found for the given filters.');
          }
        } else {
          this.toastr.error(responseData?.message || 'Failed to fetch DTs');
          this.dts = [];
          this.count = 0;
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.toastr.error('Error occurred while fetching DTs');
        this.dts = [];
        this.count = 0;
      },
    });
  }

  reloadTable(page: number | null = null) {
    if (page) this.currentPage = page;
    let obj = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: this.getFilterObject(),
      isCrud: true,
      utilityId: this.utilityId
    };
    this.getAllDts(obj);
    this.getAreas();
  }

  save() {
    if (!this.updatedDt.name) {
      this.toastr.warning("DT Name can't be empty!");
      return;
    }
    if (!this.updatedDt.number) {
      this.toastr.warning("DT Number can't be empty!");
      return;
    }
    if (!this.selectedEditArea) {
      this.toastr.warning('Please select a District.');
      return;
    }
    if (this.editFeederVoltageOption === 'Feeder Voltage') {
      this.toastr.warning('Please select a Feeder Voltage.');
      return;
    }
    if (!this.selectedEditFeeder) {
      this.toastr.warning('Please select a Feeder.');
      return;
    }

    this.updatedDt.utilityId = this.utilityId;
    this.updatedDt.id = this.isEditMode ? this.selectedDt.id : 0;
    this.updatedDt.area = this.selectedEditArea;
    this.updatedDt.feeder = this.selectedEditFeeder;
    this.updatedDt.feederType = this.editFeederVoltageOption === '33kV' ? FeederType.KV33 : FeederType.KV11;
    this.updatedDt.meterBrandId = this.selectedEditMeterBrand?.id;

    this.dtService.saveCrud(mapObjToCreateObj(this.updatedDt)).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.toastr.success(this.isEditMode ? 'Distribution Substation updated successfully' : 'Distribution Substation added successfully');
          setTimeout(() => {
            this.reloadTable(1);
            this.closeEditModal?.nativeElement?.click();
          }, 500);
        } else {
          this.toastr.error(responseData?.message || 'Failed to save Distribution Substation.');
        }
      },
      error: (error) => {
        this.toastr.error('Error occurred while saving Distribution Substation.');
      },
    });
  }

  deleteDt() {
    this.dtService.delete(this.selectedDt.id).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.toastr.success(responseData?.message || 'Distribution Substation deleted successfully');
          this.showDeleteModal = false;
          this.onPageChange(1);
        } else {
          this.toastr.error(responseData?.message || 'Failed to delete Distribution Substation');
        }
      },
      error: (error) => {
        this.toastr.error('Error occurred while deleting Distribution Substation');
        this.showDeleteModal = false;
      },
    });
  }

  download() {
    let dataIn = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: this.getFilterObject(),
      utilityId: this.utilityId
    };
    this.dtService.downloadFileCrud(dataIn).subscribe({
      next: (response) => {
        window.location.href = response.data;
      },
      error: (error) => {
        this.toastr.error('An error occurred while downloading the file.');
        this.reloadTable(this.currentPage);
      },
    });
  }

  onPageChange(newPage: number) {
    this.currentPage = newPage;
    this.reloadTable(newPage);
  }

  onAreaCheckedChange(area: Area, event: any) {
    area.checked = event.target.checked;
    this.applyFilter();
  }
}